<template>
    <DxDataGridSucesos :dxDataSourceProp="dxDataGridSource" :vistaWikiProp="false" />
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue';
import { useApi } from '@/.shared/.api/integration';
import type CustomStore from 'devextreme/data/custom_store';
import type { DXLoadOptions, OsciloDetalleModel } from '@/.shared/.api';
import DxDataGridSucesos from '@/components/sucesos/DxDataGridSucesos.vue';

const props = defineProps<{ osciloProp: OsciloDetalleModel }>();
const oscilo = computed(() => props.osciloProp);

const api = useApi();
const dxDataGridSource = ref<CustomStore>();

watch(() => (props.osciloProp), (nuevoOscilo: OsciloDetalleModel) => {
    if (nuevoOscilo.Id != null) {
        var a = api.apiStore({
            key: "Id",
            load: async (opt: DXLoadOptions) => {
                return await api.callStandardApi("sucesoGetRejilla", { showLoading: false }, opt, oscilo.value.Id);
            }
        });

        dxDataGridSource.value = api.apiStore({
            key: "Id",
            load: async (opt: DXLoadOptions) => {
                return await api.callStandardApi("sucesoGetRejilla", { showLoading: false }, opt, oscilo.value.Id);
            }
        });
    }
}, { immediate: true });
</script>